<!-- KYMW4601 タグ集約 -->
<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">タグ集約</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <div>
          <h1>集約対象タグ一覧</h1>
          <span>
            集約先のタグを選択してください。<br />
            &#8251;選択しなかったタグは集約先のタグに置き換わります。
          </span>
          <!-- FlexGird -->
          <wj-flex-grid #dtg_TagList [itemsSource]="model.tagList" [allowDragging]="'None'" horizontalScrollPolicy="off"
            [headersVisibility]="'Column'" [selectionMode]="'Row'" verticalScrollPolicy="on" [autoRowHeights]="true"
            [allowSorting]="false" [tabOrder]="-1">
            <!-- column ラジオボタン -->
            <wj-flex-grid-column [dataMap]="dataMap" [dataMapEditor]="'RadioButtons'" [width]="40" [header]="' '"
              [binding]="'radioVal'" [align]="'center'" (click)="$event.stopPropagation()" cssClass="radio-cell" [minWidth]="5">
            </wj-flex-grid-column>
            <!-- column 集約対象タグ名 -->
            <wj-flex-grid-column [header]="'集約対象タグ名'" [width]="508" [binding]="'tagName'"
              [isReadOnly]="true" [minWidth]="5"></wj-flex-grid-column>
          </wj-flex-grid>
        </div>
      </div>
    </td>
  </tr>

  <!-- フッター -->
  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <!-- button 集約 -->
          <button #btn_Aggregate id="btn_Aggregate" class="btn-primary" (click)="aggregateTags()"
            [tabindex]="0">集約</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>

</table>